import React, { useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import dayjs from "dayjs";

import { ModalContainer } from "~components/ModalContainer";
import DateRangePicker from "~components/DateRangePicker/DateRangePicker";

interface BulkPaymentStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (date: Date) => void;
  isLoading?: boolean;
}

export const BulkPaymentStatusModal: React.FC<BulkPaymentStatusModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleConfirm = () => {
    if (selectedDate) {
      onConfirm(selectedDate);
    }
  };

  const handleClose = () => {
    setSelectedDate(null);
    onClose();
  };

  const handleDateChange = (dates: Date[]) => {
    setSelectedDate(dates.length > 0 ? dates[0] : null);
  };

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={handleClose}
      title="Mark All As Paid"
      leftButtonTitle="Cancel"
      rightButtonTitle="Confirm"
      onClickLeftButton={handleClose}
      onClickRightButton={handleConfirm}
      leftButtonEnabled={!isLoading}
      rightButtonEnabled={!isLoading && selectedDate !== null}
    >
      <Box py="4">
        <Text textStyle="sm" color="gray.400" mb="4">
          Select a date to mark all studies completed on or before this date as paid.
        </Text>
        <DateRangePicker
          onDatesChange={handleDateChange}
          variant="single"
          buttonStyle={{ minW: "100%" }}
        />
        {selectedDate && (
          <Text textStyle="sm" color="gray.300" mt="4">
            All studies completed on or before {dayjs(selectedDate).format("MM/DD/YYYY")}{" "}
            will be marked as paid.
          </Text>
        )}
      </Box>
    </ModalContainer>
  );
};
